import { type ReactNode, useState } from 'react';

// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Button, Popover, Typography } from '@material-ui/core';

import { RiPulseLine } from '@remixicon/react';

import type { InlineNumberBlock } from '@spotify/plugin-confidence-chat-react';
import {
  PULSE_BLOCK_TYPE,
  SaveToPulseDialog,
} from '@spotify/plugin-confidence-pulse-react';

import styles from './PulseNumberHighlight.module.css';

type PulseNumberHighlightProps = {
  block: InlineNumberBlock;
  sourceChat: string;
  value: ReactNode;
};

export const PulseNumberHighlight = ({
  block,
  sourceChat,
  value,
}: PulseNumberHighlightProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const openSaveDialog = () => {
    setAnchorEl(null);
    setDialogOpen(true);
  };

  return (
    <>
      <button
        type="button"
        className={styles.number}
        onClick={event => setAnchorEl(event.currentTarget)}
        aria-haspopup="dialog"
        aria-expanded={Boolean(anchorEl)}
        aria-label={`${block.name}: ${block.value}. Save to pulse`}
      >
        {value}
      </button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{ role: 'dialog', 'aria-label': block.name }}
      >
        <div className={styles.popover}>
          <Typography variant="body2" color="textSecondary">
            {block.name}
          </Typography>
          <Typography variant="h6">{block.value}</Typography>
          <div className={styles.popoverActions}>
            <Button
              variant="outlined"
              size="small"
              startIcon={<RiPulseLine size={16} />}
              onClick={openSaveDialog}
            >
              Add to pulse
            </Button>
          </div>
        </div>
      </Popover>
      {dialogOpen && (
        <SaveToPulseDialog
          isOpen={dialogOpen}
          onOpenChange={setDialogOpen}
          input={{
            sourceChat,
            sourceEvent: block.eventName,
            blockType: PULSE_BLOCK_TYPE.BIG_NUMBER,
            suggestedName: block.name,
          }}
        />
      )}
    </>
  );
};
